module.exports = __webpack_public_path__ + "static/media/Files.9c4e11ac.svg";